GloboSwatchConfig.settings = {
            enable_collection_page: false,
            enable_product_page: true,
            out_of_stock: "cross out",
            enable_mandatory: false,
            show_add_to_cart_button: true,
            add_to_cart_ajax: true,
            show_option_name: false,
            add_to_cart_text: "Add to cart",
            added_to_cart_text: "Added to cart",
            sold_out_text: "Sold out",
            text_required: "This field is required",
            sort_option: true        };
        GloboSwatchConfig.options = [{"id":31097,"name":"Color","shop_id":5892,"option_items":[{"id":742194,"value":"Matte Black + Walnut","option_id":31097,"products":null,"products_count":9,"select_type":3,"custom":{"color_1":"transparent","color_2":"transparent","upload_file":{"src":"1625433806.jpg","server_url":"https:\/\/option.nyc3.digitaloceanspaces.com\/files\/canbramar-home.myshopify.com\/1625433806.jpg"},"image_url":{"src":"","server_url":null},"enable_two_color":false,"enable_upload_file":true,"enable_image_url":false}},{"id":742195,"value":"Matte Black + Natural","option_id":31097,"products":null,"products_count":3,"select_type":3,"custom":{"color_1":"transparent","color_2":"transparent","upload_file":{"src":"1625454901.jpg","server_url":"https:\/\/option.nyc3.digitaloceanspaces.com\/files\/canbramar-home.myshopify.com\/1625454901.jpg"},"image_url":{"src":"","server_url":null},"enable_two_color":false,"enable_upload_file":true,"enable_image_url":false}},{"id":742196,"value":"Black","option_id":31097,"products":null,"products_count":11,"select_type":2,"custom":{"color_1":"#000000","color_2":"#000000","upload_file":{"src":null,"server_url":null},"image_url":{"src":"","server_url":null},"enable_two_color":true,"enable_upload_file":false,"enable_image_url":false}},{"id":742197,"value":"Brown","option_id":31097,"products":null,"products_count":7,"select_type":2,"custom":{"color_1":"#42280e","color_2":"#42280e","upload_file":{"src":null,"server_url":null},"image_url":{"src":"","server_url":null},"enable_two_color":true,"enable_upload_file":false,"enable_image_url":false}},{"id":742199,"value":"White","option_id":31097,"products":null,"products_count":13,"select_type":2,"custom":{"color_1":"#ffffff","color_2":"#ffffff","upload_file":{"src":null,"server_url":null},"image_url":{"src":"","server_url":null},"enable_two_color":true,"enable_upload_file":false,"enable_image_url":false}},{"id":938649,"value":"Matte Black + Black","option_id":31097,"products":null,"products_count":8,"select_type":3,"custom":{"color_1":"transparent","color_2":"transparent","upload_file":{"src":"1627057820.jpg","server_url":"https:\/\/option.nyc3.digitaloceanspaces.com\/files\/canbramar-home.myshopify.com\/1627057820.jpg"},"image_url":{"src":"","server_url":null},"enable_two_color":false,"enable_upload_file":true,"enable_image_url":false}},{"id":938650,"value":"Matte White + Light Walnut","option_id":31097,"products":null,"products_count":8,"select_type":3,"custom":{"color_1":"transparent","color_2":"transparent","upload_file":{"src":"1627057951.jpg","server_url":"https:\/\/option.nyc3.digitaloceanspaces.com\/files\/canbramar-home.myshopify.com\/1627057951.jpg"},"image_url":{"src":"","server_url":null},"enable_two_color":false,"enable_upload_file":true,"enable_image_url":false}},{"id":938651,"value":"Matte White + Grey","option_id":31097,"products":null,"products_count":9,"select_type":3,"custom":{"color_1":"transparent","color_2":"transparent","upload_file":{"src":"1627058005.jpg","server_url":"https:\/\/option.nyc3.digitaloceanspaces.com\/files\/canbramar-home.myshopify.com\/1627058005.jpg"},"image_url":{"src":"","server_url":null},"enable_two_color":false,"enable_upload_file":true,"enable_image_url":false}}],"display_style":1,"settings":{"status":true,"enable_collection":false,"type":"swatch"},"products":null,"products_count":13,"order":1},{"id":31098,"name":"Title","shop_id":5892,"option_items":[{"id":742198,"value":"Default Title","option_id":31098,"products":null,"products_count":14,"select_type":1,"custom":{"color_1":"transparent","color_2":"transparent","upload_file":{"src":null,"server_url":null},"image_url":{"src":null,"server_url":null},"enable_two_color":false,"enable_upload_file":false,"enable_image_url":false}}],"display_style":1,"settings":{"status":true,"enable_collection":false,"type":"swatch"},"products":null,"products_count":14,"order":2}];
        GloboSwatchConfig.product_page= {
                customize_swatch: {
                    swatch_shape: 'square',
                    swatch_size: 'large',
                    border_style: 'single',
                    border_color: {
                        normal: '#9b9b9b',
                        hover: '#9e1010',
                        selected: '#9e1010'
                    },
                    hover_effects:{
                        background: 'add shadow',
                        zoom_image: 'no zoom',
                        size_change: 'no change'
                    }
                },
                customize_button: {
                    button_corner: 'rounded',
                    button_size: 'large',
                    border_color: {
                        normal: '#000000',
                        hover: '#9e1010',
                        selected: '#9e1010'
                    },
                    text_style: 'default',
                    text_color: {
                        normal: '#000000',
                        hover: '#ffffff',
                        selected: '#ffffff'
                    },
                    background_color: {
                        normal: '#fff',
                        hover: '#9e1010',
                        selected: '#9e1010'
                    },
                    hover_effects:{
                        background: 'add glow',
                    }
                },
                show_number_stock: '1',
                float: 'left'
            };
            GloboSwatchConfig.collection_page ={
                customize_swatch: {
                    swatch_shape: 'square',
                    swatch_size: 'large',
                    border_style: 'double',
                    border_color: {
                        normal: '#9b9b9b',
                        hover: '#6e0505',
                        selected: '#6e0505'
                    },
                    hover_effects:{
                        background: 'add shadow',
                        zoom_image: 'zoom',
                        size_change: 'increase size'
                    }
                },
                customize_button: {
                    button_corner: 'sharp',
                    button_size: 'large',
                    border_color: {
                        normal: '#000000',
                        hover: '#000000',
                        selected: '#000000'
                    },
                    text_style: 'default',
                    text_color: {
                        normal: '#0a0a0a',
                        hover: '#ffffff',
                        selected: '#ffffff'
                    },
                    background_color: {
                        normal: '#ffffff',
                        hover: '#000000',
                        selected: '#000000'
                    },
                    hover_effects:{
                        background: 'add shadow',
                    }
                },
                float: 'center'
        };